// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { TradePartnerDetailsFragmentDoc } from './TradePartnerDetailsTab.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnerPageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TradePartnerPageQuery = { __typename?: 'Query', tradePartner: { __typename?: 'TradePartner', id: string, name: string, isSweetheart: boolean, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus } } };

export type TradePartnerPageTradePartnerFragment = { __typename?: 'TradePartner', id: string, name: string, isSweetheart: boolean, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus } };

export type SaveTradePartnerMutationVariables = Types.Exact<{
  input: Types.SaveTradePartnerInput;
}>;


export type SaveTradePartnerMutation = { __typename?: 'Mutation', saveTradePartner: { __typename?: 'SaveTradePartnerResult', tradePartner: { __typename?: 'TradePartner', id: string, name: string, isSweetheart: boolean, website?: string | null | undefined, internalNote?: string | null | undefined, intacctId?: string | null | undefined, doesMaterials: boolean, doesLabor: boolean, sourceNote?: string | null | undefined, meetsRequirements: boolean, isLienWaiverReceiver: boolean, enableClickToPay: boolean, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus }, markets: Array<{ __typename?: 'Market', id: string }>, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string }>, source?: { __typename?: 'InternalUser', id: string } | null | undefined, paymentTerm: { __typename?: 'PaymentTerm', id: string, name: string } } } };

export type DeleteTradePartnerMutationVariables = Types.Exact<{
  input: Types.DeleteTradePartnerInput;
}>;


export type DeleteTradePartnerMutation = { __typename?: 'Mutation', deleteTradePartner: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export const TradePartnerPageTradePartnerFragmentDoc = gql`
    fragment TradePartnerPageTradePartner on TradePartner {
  id
  name
  isSweetheart
  onboardingStatus {
    code
  }
}
    `;
export const TradePartnerPageDocument = gql`
    query TradePartnerPage($id: ID!) {
  tradePartner(id: $id) {
    ...TradePartnerPageTradePartner
  }
}
    ${TradePartnerPageTradePartnerFragmentDoc}`;

/**
 * __useTradePartnerPageQuery__
 *
 * To run a query within a React component, call `useTradePartnerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTradePartnerPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnerPageQuery, TradePartnerPageQueryVariables> & ({ variables: TradePartnerPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerPageQuery, TradePartnerPageQueryVariables>(TradePartnerPageDocument, options);
      }
export function useTradePartnerPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerPageQuery, TradePartnerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerPageQuery, TradePartnerPageQueryVariables>(TradePartnerPageDocument, options);
        }
// @ts-ignore
export function useTradePartnerPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerPageQuery, TradePartnerPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerPageQuery, TradePartnerPageQueryVariables>;
export function useTradePartnerPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerPageQuery, TradePartnerPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerPageQuery | undefined, TradePartnerPageQueryVariables>;
export function useTradePartnerPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerPageQuery, TradePartnerPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnerPageQuery, TradePartnerPageQueryVariables>(TradePartnerPageDocument, options);
        }
export type TradePartnerPageQueryHookResult = ReturnType<typeof useTradePartnerPageQuery>;
export type TradePartnerPageLazyQueryHookResult = ReturnType<typeof useTradePartnerPageLazyQuery>;
export type TradePartnerPageSuspenseQueryHookResult = ReturnType<typeof useTradePartnerPageSuspenseQuery>;
export type TradePartnerPageQueryResult = Apollo.QueryResult<TradePartnerPageQuery, TradePartnerPageQueryVariables>;
export const SaveTradePartnerDocument = gql`
    mutation SaveTradePartner($input: SaveTradePartnerInput!) {
  saveTradePartner(input: $input) {
    tradePartner {
      ...TradePartnerPageTradePartner
      ...TradePartnerDetails
    }
  }
}
    ${TradePartnerPageTradePartnerFragmentDoc}
${TradePartnerDetailsFragmentDoc}`;
export type SaveTradePartnerMutationFn = Apollo.MutationFunction<SaveTradePartnerMutation, SaveTradePartnerMutationVariables>;

/**
 * __useSaveTradePartnerMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerMutation, { data, loading, error }] = useSaveTradePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerMutation, SaveTradePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerMutation, SaveTradePartnerMutationVariables>(SaveTradePartnerDocument, options);
      }
export type SaveTradePartnerMutationHookResult = ReturnType<typeof useSaveTradePartnerMutation>;
export type SaveTradePartnerMutationResult = Apollo.MutationResult<SaveTradePartnerMutation>;
export type SaveTradePartnerMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerMutation, SaveTradePartnerMutationVariables>;
export const DeleteTradePartnerDocument = gql`
    mutation DeleteTradePartner($input: DeleteTradePartnerInput!) {
  deleteTradePartner(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteTradePartnerMutationFn = Apollo.MutationFunction<DeleteTradePartnerMutation, DeleteTradePartnerMutationVariables>;

/**
 * __useDeleteTradePartnerMutation__
 *
 * To run a mutation, you first call `useDeleteTradePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTradePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTradePartnerMutation, { data, loading, error }] = useDeleteTradePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTradePartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTradePartnerMutation, DeleteTradePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTradePartnerMutation, DeleteTradePartnerMutationVariables>(DeleteTradePartnerDocument, options);
      }
export type DeleteTradePartnerMutationHookResult = ReturnType<typeof useDeleteTradePartnerMutation>;
export type DeleteTradePartnerMutationResult = Apollo.MutationResult<DeleteTradePartnerMutation>;
export type DeleteTradePartnerMutationOptions = Apollo.BaseMutationOptions<DeleteTradePartnerMutation, DeleteTradePartnerMutationVariables>;